import styled from 'styled-components'

export const InfoContainer = styled.div`
    padding-top: 200px;
    color: #fff;
    background: #f9f9f9;

    @media screen and (max-width: 768px) {
        padding: 100px 0 350px;
    }
`;

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    height: 660px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;

    @media screen and (max-width: 768px) {
        height: 860px;
    }
`;

export const InfoRow = styled.div`
    display: grid;
    grid-auto-column: minmax(auto, 1fr);
    aling-items: center;
    grid-template-areas: 'col2 col1';

    @media screen and (max-width: 768px) {
        grid-template-areas: 'col1' 'col2';
    }
`;

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`;

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`;

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
`;

export const TopLine = styled.p`
    color: #01bf71;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`;

export const Heading = styled.h1`
    margin-bottom: 24px;
    font-size: 40px;
    line-height: 1.1;
    font-weight: 600;
    color: #010606;

    @media screen and (max-width: 480px) {
        font_size: 32px;
    }
`;

export const Subtitle = styled.p`
    max-width: 440px;
    font-size: 18px;
    color: #010606;
`;

export const Gain = styled.p`
    margin-top: 15px;
    max-width: 440px;
    font-size: 18px;
    color: #010606;
`;

export const MothMasterDisplay = styled.p`
    max-width: 440px;
    font-size: 30px;
    color: #010606;

    @media screen and (max-width: 768px) {
        font-size: 20px;
    }
`;

export const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 30px;
`;

export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;
`;

export const Img = styled.img`
    width: 100%;
    margin: 0 0 10px 0;
    padding-right: 0;
`;

export const MothInfoWrapper = styled.div`
    border: 3px solid #01bf71;
    border-radius: 3px;
    padding: 20px;
    margin-bottom: 20px;
`;

export const Check = styled.div`
    display: flex;
    content-align: center;
`;

export const QtyCheck = styled.div`
    margin-bottom: 20px;
`;

export const Wraper = styled.div`

`;

export const Green = styled.p`
    color: #01bf71;
`;

export const Red = styled.p`
    color: #e24c4b;
`;

export const Icon = styled.img`
    margin-right: 5px;
    max-height: 15px;
`;

export const BalShow = styled.p`
    color: #000;
    padding-left: 20px;
`;

export const TimeCheck = styled.div`

`;